import { VFC, useMemo } from 'react';
import { FormattedMessage, useIntl } from 'react-intl';
import { GSize } from '@enmon/commons';
import { Select } from '../../Select';
import { MeterDetails as messages } from '../../../Form/meter_details/messages';
import { useMeterModelSuggestionsStore } from '../../../../store/useMeterModelSuggestionsStore';
import { getSelectOptionsWithSuggestions } from '../../utils/getSelectOptionsWithSuggestions';

interface GSizeSelectProps {
  value?: GSize;
  onChange?: (value: GSize) => void;
}

export const GSizeSelect: VFC<GSizeSelectProps> = ({ ...restProps }) => {
  const intl = useIntl();
  const { meterModelSuggestions } = useMeterModelSuggestionsStore();

  const gSizeOptions = useMemo(
    () =>
      getSelectOptionsWithSuggestions({
        intl,
        values: Object.values(GSize),
        suggestedValue: meterModelSuggestions?.gSize?.value,
        suggestedSelection: meterModelSuggestions?.gSize?.selection,
      }),
    [intl, meterModelSuggestions],
  );

  return (
    <Select
      allowClear
      showArrow
      className="w-100"
      options={gSizeOptions}
      placeholder={<FormattedMessage {...messages.gSizePlaceholder} />}
      suffix={`m${String.fromCharCode(179)}/h`}
      {...restProps}
    />
  );
};
